import React, { FC, useState } from 'react';

import styled, { CSSObject } from 'styled-components';

// import RefreshBtn from 'asset/btn/btn-refresh.svg?react';

type ImageWithRetryProps = {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSObject;
  onLoad?: () => void;
};

const ImageWithRetry: FC<ImageWithRetryProps> = ({ src, alt, className, ...props }) => {
  const [retry, setRetry] = useState(0);
  const [isError, setIsError] = useState(false);

  const handleImageError = () => {
    if (retry < 3) {
      setTimeout(() => {
        handleClickRefreshButton();
      }, 500);
    } else {
      setIsError(true);
    }
  };

  const handleClickRefreshButton = () => {
    setRetry((retry) => retry + 1);
    setIsError(false);
  };

  return (
    <>
      <SImageWrapper className="image-wrapper">
        {isError ? (
          <></>
        ) : (
          // <RefreshBtn className="refresh-btn" onClick={handleClickRefreshButton} width={20} height={20} />
          <img
            key={retry}
            src={src}
            className={className ?? ''}
            alt={alt ?? ''}
            onError={handleImageError}
            loading="lazy"
            {...props}
          />
        )}
      </SImageWrapper>
    </>
  );
};

export default ImageWithRetry;

const SImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: fit-content;

  .refresh-btn {
    cursor: pointer;
  }

  img {
    -webkit-user-drag: none;
  }
`;
